// Manager.js
import { qsa } from "../utils"

export default class Manager {
  constructor() {
    this.components = []
  }

  addComponent(obj, renderer) {
    const { name, instance } = obj
    const els = qsa(`[data-${name}]`)
    const data = {}
    if (els.length === 0) return

    data.hasTick = obj.hasTick || false
    data.hasAnimateIn = obj.hasAnimateIn || false
    data.hasAnimateOut = obj.hasAnimateOut || false
    data.hasAnimateOnScroll = obj.hasAnimateOnScroll || false

    els.forEach((el, index) => {
      const component = new instance({ index, el, data, renderer })
      this.components.push({ name, component })
    })
  }

  initializeComponents() {
    this.components.forEach(({ component }) => {
      component?.render()
    })
  }

  animateIn() {
    this.components.forEach(({ component }) => {
      component.hasAnimateIn && component.animateIn()
    })
  }

  animateOut() {
    this.components.forEach(({ component }) => {
      component.hasAnimateOut && component.animateOut()
    })
  }

  animateOnScroll() {
    this.components.forEach(({ component }) => {
      component.hasAnimateOnScroll && component.animateOnScroll()
    })
  }

  update(obj) {
    this.components.forEach(({ component }) => {
      component.hasTick && component.tick(obj)
    })
  }

  resize() {
    this.components.forEach(({ component }) => {
      component?.resize()
    })
  }

  smoothResize() {
    this.components.forEach(({ component }) => {
      component?.smoothResize()
    })
  }

  destroy() {
    this.components.forEach(({ component }) => {
      component?.destroy()
    })
  }
}
